var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-row',{attrs:{"justify":"center"}},[[_c('services',{attrs:{"account":_vm.account,"show-balance":true}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }